export const getSummaryWrapperStyles = length => ({
  display: 'grid',
  gridTemplateColumns: {
    xs: 'repeat(1, 1fr)',
    sm: 'repeat(2, 1fr)',
    md: `repeat(${length}, 1fr)`,
  },
  gap: '8px',
  flex: 1,
});

export const summaryCardStyles = {
  display: 'flex',
  overflow: 'hidden',
  padding: '4px 8px',
};

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  padding: '24px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  boxShadow: ({ palette }) => palette.shadow.m,
};

export const skeletonWrapperStyles = {
  ...wrapperStyles,
  padding: '40px 48px 28px',
  gap: '0',
};

export const summaryHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
};

export const titleTypographyStyles = {
  fontSize: '1.8rem',
  fontWeight: 600,
  lineHeight: '2.1rem',
  color: ({ palette }) => palette.text.primary,
};

export const commonTooltipStyles = {
  padding: '24px',
  maxWidth: 'none',
  color: ({ palette }) => palette.text.primary,
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: '5px 0px 12px 0px #00000026, 0px 5px 12px 0px #00000026',
};
